// api.ts
import axios from 'axios'
import endpoints from '../../endpoints'
import {VehicleMovementReportPayload, VehicleMovementReportBase} from './type'
import {APIResponse} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchVehicleMovementReport(
  payload: VehicleMovementReportPayload
): Promise<APIResponse<VehicleMovementReportBase[]>> {
  const response = await axios.post(API_URL + endpoints.reports.vehiclemovementReport, payload)
  return response.data
}
